import { httpClient } from '@/utils/http-client';
class PromptService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    formatObject(clip) {
        return {
            id: clip.id,
            topic: clip.topic,
            text: clip.text,
            indices: clip.indices,
            rating: clip.rating,
            startTime: clip.startTime,
            endTime: clip.endTime
        };
    }
    async getVideoHooks(videoId) {
        const response = await this.httpClient.get('/clips/video/' + videoId);
        return response.data.map((clip) => {
            return this.formatObject(clip);
        });
    }
    async getPromptStatus(videoId) {
        const response = await this.httpClient.get('/prompts/status/' + videoId);
        return response.data;
    }
    async regenerateAISC(videoId, llm) {
        const response = await this.httpClient.get(`/prompts/regenerate/${llm}/${videoId}`);
        return response.data;
    }
}
export default PromptService;
